// localStorage persistence for per-eye annotation hotspots. Keyed by
// eye id so each eye gets its own row; cleared all at once by
// `clearAllAnnotations()`.

import type { Annotation } from '../types/annotations';

const PREFIX = 'stamps:annotations:v1:';
export function loadAnnotations(eyeId: string): Annotation[] {
  try {
    const raw = localStorage.getItem(PREFIX + eyeId);
    return raw ? (JSON.parse(raw) as Annotation[]) : [];
  } catch { return []; }
}
export function saveAnnotations(eyeId: string, annotations: Annotation[]): void {
  try { localStorage.setItem(PREFIX + eyeId, JSON.stringify(annotations)); } catch { /* quota */ }
}
export function clearAllAnnotations(): void {
  try {
    const keys = Object.keys(localStorage).filter((k) => k.startsWith(PREFIX));
    for (const k of keys) localStorage.removeItem(k);
  } catch { /* */ }
}